export const PROD_TOKEN = "f-$2sP1^1Xf+YD63ayjd$X8baHx;4X/5&n`_1jzFnMjD2e9HWV9.Dy~7'Y@y5^av";
export const DEV_TOKEN = "edc2023";
// Local dev also uses production API; prod token is required for sodit.cyou:7443
export const TOKEN = import.meta.env.VITE_API_TOKEN || PROD_TOKEN;

export const API_NAMES = {
  HOME: 'home-api',
  IMMI: 'immi-api',
  YOUTUBE: 'youtube-api',
  RSS: 'rss-api'
};

export const COUNTRY_CODES = {
  NZ: 'nz',
  AU: 'au',
  CA: 'ca'
};

export const LANGUAGE_CODES = {
  EN: 'en',
  KO: 'ko'
};

export const ROWS_PER_PAGE = {
  FIFTY: 50,
  HUNDRED: 100
}; 